<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title flex-end">View List of Pop Up Pages</div>
      <div>
        <!-- <div class="col-lg-6 col-xl-7 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <multiselect
              :options="dropdownstatus"
              track-by="id"
              v-model="selectedDropdownStatus"
              :searchable="true"
              label="name"
              placeholder="Filter By Status"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div> -->

        <router-link class="btn-blue" :to="'/pop-up-pages/add-popup-page'">{{
          $t("Add")
        }}</router-link>
        <b-dropdown id="listview" variant="outline-blue" :text="listContent">
          <b-dropdown-item
            v-for="(list, listIndex) in filterGroup"
            :key="listIndex"
            @click="filterData(list)"
            href="#"
            >{{ list.pp_name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
    <div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <table class="list-view-table">
              <thead>
                <tr>
                  <th>Page Name</th>
                  <th>Language</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="pagesData.length > 0">
                <tr v-for="(item, index) in pagesData" :key="index">
                  <td>
                    {{ item.pp_name }}
                    {{ item.rating ? `(${item.rating})` : "" }}
                  </td>
                  <td>{{ item.lang_name }}</td>
                  <td>{{ item.pp_title }}</td>
                  <td v-html="item.pp_description"></td>
                  <td>
                    <div class="image-placeholder">
                      <!-- <img src="@/assets/img/temp/movie.jpg" /> -->
                      <img
                        :src="
                          item.pp_banner.startsWith('http')
                            ? item.pp_banner.replace(/([^:]\/)\/+/g, '$1')
                            : item.pp_banner.startsWith('S3') ||
                              item.pp_banner.startsWith('/S3')
                            ? IMGBASEURL + item.pp_banner
                            : item.pp_banner
                        "
                        width="100"
                        height="100"
                      />
                    </div>
                  </td>
                  <td>
                    <span @click="onClickStatusDot(item)">
                      <StatusDot
                        :status="item.is_active == 'Y' ? 'active' : 'inactive'"
                      />
                    </span>
                  </td>
                  <td class="text-right">
                    <b-dropdown right variant="edit" class="ml-4">
                      <b-dropdown-item
                        @click="goToRoute('/pages/edit-popup-page', item)"
                      >
                        <span class="edit-pen"></span>
                        {{ $t("edit") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="pagesData.length == 0">
                <tr>
                  <td colspan="3">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3"
          >Are you sure you want to
          {{ selectedPop.is_active == "Y" ? "Inactive" : "Active" }} this Pop
          Page?</p
        >
        <span class="mx-1"></span>
        <button
          v-if="selectedPop.is_active == 'N'"
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('Y')"
        >
          Active
        </button>
        <button
          v-else
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('N')"
        >
          Inactive
        </button>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import ExhibitorService from "@/services/ExhibitorService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import { IMGBASEURL } from "@/config/index.js";
  import _ from "lodash";

  export default {
    name: "View Pop Up Pages",
    components: {
      StatusDot,
      NoRecords,
    },
    data() {
      return {
        dropdownstatus: [
          { id: 1, value: "", name: "All" },
          { id: 2, value: "Y", name: "Active" },
          { id: 3, value: "N", name: "Inactive" },
        ],
        selectedDropdownStatus: "",
        pagesData: [],
        IMGBASEURL: IMGBASEURL,
        listContent: "Select Filter",
        selectedPop: {
          pp_id: null,
          pp_type_id: null,
          pp_name: "",
          pp_lang_id: null,
          pp_rating_type: "",
          pp_banner: "",
          pp_title: "",
          pp_country_id: "",
          pp_image_url: "",
          pp_description: "",
          is_active: "Y",
        },
        filterGroup: [
          {
            pp_name: "All",
            pp_type_id: "",
          },
          {
            pp_name: "PopUp",
            pp_type_id: "1",
          },
          {
            pp_name: "Rating",
            pp_type_id: "2",
          },
        ],
      };
    },
    watch: {
      selectedDropdownStatus(status) {
        this.selectedDropdownStatus = status;
      },
    },
    beforeMount() {
      this.getListOfPopUpPages();
    },
    methods: {
      UpdateStatus(status) {
        let loader = this.$loading.show();
        this.$bvModal.hide("confirmation_active_inactive");

        let payload = {
          pp_id: this.selectedPop["pp_id"],
          is_active: status
            ? status
            : this.selectedPop["is_active"] == "Y"
            ? "N"
            : "Y",
        };
        ExhibitorService.UpdatePopupPageStatus(payload)
          .then((response) => {
            const { data } = response;
            this.getListOfPopUpPages();
            console.log(data.message);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onClickStatusDot(item) {
        console.log("CLICKING onClickStatusDot", item);
        this.selectedPop = _.cloneDeep(item);
        this.$bvModal.show("confirmation_active_inactive");
      },
      getListOfPopUpPages() {
        let payload = {
          is_active: this.selectedDropdownStatus.value,
        };
        ExhibitorService.GetListOfPopUpPages(payload)
          .then((response) => {
            const { data } = response;
            if (data.Records.length > 0) {
              //console.log(data.Records);
              // this.pagesData = data.Records;
              let pageData = data.Records;
              this.pagesData = pageData;
            } else {
              //console.log("data.message", data.message);
            }
          })
          .catch((error) => {
            //console.log(error);
          });
      },
      goToRoute: function(path, item) {
        //console.log("item :", item);
        const { pp_id } = item;
        this.$router.push({
          path: path,
          query: {
            pp_id: pp_id,
          },
        });
      },
      filterData(item) {
        console.log(item);
        let payload = {
          pp_type_id: item.pp_type_id,
        };
        ExhibitorService.GetListOfPopUpPages(payload)
          .then((response) => {
            const { data } = response;
            if (data.Records.length > 0) {
              console.log(data.Records);
              // this.pagesData = data.Records;
              let pageData = data.Records;
              this.pagesData = pageData;
            } else {
              this.pagesData = [];
              //console.log("data.message", data.message);
            }
          })
          .catch((error) => {
            //console.log(error);
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/viewListOfPopUpPages.vue